import type { ReactNode } from 'react'
import styles from './Card.module.css'

/** A neutral surface used to group related content across screens. */
export function Card({ children }: { children: ReactNode }) {
  return <section className={styles.card}>{children}</section>
}
